import { LinearProgress } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

function ScrollProgress() {
  const progressRef = useRef(0); // Avoid state re-renders
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const newProgress = (scrollTop / scrollHeight) * 100;

      // Only update state if progress actually changes
      if (Math.abs(progressRef.current - newProgress) > 1) {
        progressRef.current = newProgress;
        setProgress(newProgress);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{ height: 5, bgcolor: 'transparent' }}
      />
    </>
  );
}

export default ScrollProgress;
